
import { createSelector } from 'reselect';

const obtenirNumeroMaximDeFotos = (estructura) => {
    return estructura.fotos.numeroMaximDeFotos;
};

const obtenirMidaMaximaFotosEnBytes = (estructura) => {
    return estructura.fotos.midaMaximaFotosEnBytes;
};

const estructura = state => state.estacio.formulari.estructura;

export const selectorNumeroMaximDeFotos = createSelector(
    estructura,
    obtenirNumeroMaximDeFotos
);

export const selectorMidaMaximaFotosEnBytes = createSelector(
    estructura,
    obtenirMidaMaximaFotosEnBytes
);

const obtenirGrupsVariables = (estructura) => estructura.grupsVariables;

const obtenirVariables = (estructura) => estructura.variables;

const obtenirVariablesMoments = (estructura) => estructura.variablesMoments;

const obtenirMoments = (estructura) => estructura.moments;

export const selectorGrupsVariables = createSelector(
    estructura,
    obtenirGrupsVariables
);

export const selectorVariables = createSelector(
    estructura,
    obtenirVariables
);

export const selectorVariablesMoments = createSelector(
    estructura,
    obtenirVariablesMoments
);

export const selectorMoments = createSelector(
    estructura,
    obtenirMoments
);

export const selectorGrupsMetadades = createSelector(
    estructura,
    (estructura) => estructura.grupsMetadades
);

export const selectorMetadades = createSelector(
    estructura,
    (estructura) => estructura.metadades
);

export const selectorCampsMetadades = createSelector(
    estructura,
    (estructura) => estructura.campsMetadades
);

const obtenirOpcionsTipusEstacio = estructura => estructura.tipusEstacio;

export const selectorOpcionsTipusEstacio = createSelector(
    estructura,
    obtenirOpcionsTipusEstacio
);

export const selectorTipusIncidencies = createSelector(
    estructura,
    estructura => estructura.tipusIncidencies
);

const transformarTipusIncidenciesEnArray = tipusIncidencies => {
    return Object.keys(tipusIncidencies)
        .map(idTipusText => ({ id: Number(idTipusText), nom: tipusIncidencies[idTipusText]}));
};

export const selectorTipusIncidenciesEnFormatArray = createSelector(
    selectorTipusIncidencies,
    transformarTipusIncidenciesEnArray
);

const obtenirVariablesObligatories = variables => {

    let variablesObligatories = [];

    Object.keys(variables).forEach(idVariable => {
        const variable = variables[idVariable];

        if (variable.obligatoria) {
            variablesObligatories.push(variable);
        }

    });

    return variablesObligatories;

};

const selectorVariablesObligatories = createSelector(
    selectorVariables,
    obtenirVariablesObligatories
);

export const selectorNomsVariablesObligatories = createSelector(
    selectorVariablesObligatories,
    variablesObligatories => variablesObligatories.map(variable => variable.nom)
);

const obtenirIdsVariablesMomentsObligatoris = variablesObligatories => {

    let variablesMomentsObligatoris = [];

    variablesObligatories.forEach(variable => {
        variablesMomentsObligatoris = variablesMomentsObligatoris.concat(variable.idVariablesMoments);
    });

    return variablesMomentsObligatoris;
};

export const selectorIdsVariablesMomentsObligatoris = createSelector(
    selectorVariablesObligatories,
    obtenirIdsVariablesMomentsObligatoris
);



// WEBPACK FOOTER //
// ./src/selectors/selector_estacio_formulari_estructura.js